import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccProductsResponse } from '@catalog/const';
import { PAGE_SIZE } from '@catalog/const/v2';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { CustomProduct, OCC_ENDPOINTS } from '@product/const';
import { ConverterService, OccEndpointsService, PRODUCT_NORMALIZER } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OccCatalogProductService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converter: ConverterService,
  ) {}

  loadProductsByCodes(productCodes: string[]): Observable<OccProductsResponse> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.productsByCodes, {
      queryParams: {
        query: productCodes.join(','),
        pageSize: PAGE_SIZE,
        // eslint-disable-next-line max-len
        fields: `products(dealType,bonus,code,slug,name,unit,units,unitPrices(FULL),availableInStores(FULL),badges(DEFAULT),multiunit,price(FULL),crossedPrice(FULL),transitPrice(FULL),personalPrice(FULL),categories(FULL),categoryNamesForAnalytics,images(DEFAULT),stock(FULL),isArchive,classifications)`,
      },
    });

    return this.http
      .get<OccProductsResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.productsByCodes),
      })
      .pipe(
        map((response: OccProductsResponse) => {
          return {
            products: response.products.map(
              (product) => this.converter.convert(product, PRODUCT_NORMALIZER) as CustomProduct,
            ),
          };
        }),
      );
  }
}
